import * as React from 'react'

export const ProductStrategy: React.FC = () => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0'
    y='0'
    viewBox='0 0 210 210'
    xmlSpace='preserve'
  >
    <style>
      {
        '.st0ProductStrategy{enable-background:new;fill:var(--color-badge-text)}.st1ProductStrategy{stroke:var(--color-badge-text);stroke-miterlimit:10}.st1ProductStrategy,.st2ProductStrategy,.st3ProductStrategy{fill:none;stroke-width:1.25}.st2ProductStrategy{stroke:#3c388f;stroke-miterlimit:9.9999}.st3ProductStrategy{stroke:var(--color-badge-text);stroke-linecap:round;stroke-linejoin:round}.st4ProductStrategy{fill:#a5a5ff}.st18{fill:var(--color-badge-text); stroke:var(--color-badge-text)}'
      }
    </style>
    <path
      d='m3.7 106.4.6-5.9c.2-1.5.8-2.6 1.7-3.2.8-.5 1.7-.8 2.8-.7 2.6.3 4 1.9 3.7 5l-.4 3.9 6 .6-.2 1.8-14.2-1.5zm7-1.1.4-3.7c.2-2-.7-3.1-2.3-3.2-1.7-.2-2.7.8-2.9 2.6l-.4 3.8 5.2.5zM6.4 88.6l1.9-6.4c.7-2.4 2.7-3.6 4.9-3 1.7.5 2.7 1.6 2.7 3.4h.1c.9-1.3 2-1.4 4.1-1 2.3.5 2.9.4 3.1.2h.1l-.5 1.9c-.3.2-.9.1-3.2-.4-2.1-.5-3 .2-3.5 2L15 89.1l5.8 1.7-.5 1.7-13.9-3.9zm7 .1 1.2-4.1c.6-1.9-.1-3.2-1.7-3.6-1.7-.5-2.7 0-3.3 2.1l-1.2 4.2 5 1.4zM18.5 74.1c-3.8-2-5.4-5.8-3.4-9.6 2-3.8 6-4.8 9.8-2.8 3.8 2 5.4 5.8 3.4 9.6s-6 4.7-9.8 2.8zm5.6-10.8c-3-1.5-6.1-1.1-7.6 1.9s-.1 5.8 2.9 7.3 6 1.1 7.6-1.9c1.5-3 .1-5.8-2.9-7.3zM23.3 51.4l3.3-4.1c2.7-3.4 6.2-3.1 9.6-.4 3.3 2.7 4.2 6.2 1.5 9.5l-3.2 3.9-11.2-8.9zm13 4.1c2.1-2.6 1.3-5-1.4-7.1s-5.1-2.6-7.3 0l-2 2.6 8.7 7 2-2.5zM42.4 44.1l-6.3-7.4 1.4-1.2 6.2 7.2c1.6 1.9 3.3 1.8 5.1.2 1.7-1.5 2.1-3.1.5-5l-6.2-7.2 1.4-1.2 6.3 7.4c2.2 2.6 1.3 5.3-1 7.2-2.5 2.2-5.2 2.7-7.4 0zM54.5 31.3c-2.1-3.6-1.5-7.7 2.2-9.8 2.9-1.7 5.6-1 7.2 1.1l-1.5.9c-1.2-1.4-3-1.7-5-.6-2.7 1.6-3 4.6-1.3 7.6s4.6 4.1 7.2 2.7c2.3-1.3 2.5-3.6 1.7-5.5l1.5-.9c.7 1.2.9 3 .5 4.3-.4 1.3-1.4 2.5-3 3.4-3.5 1.9-7.4.5-9.5-3.2zM68 16.1l10.6-3.7.5 1.5-4.5 1.6 4.2 12-1.6.5L73 16l-4.5 1.6-.5-1.5zM94 18.6l1.8-.2c.5 2.4 2.1 3.5 4.8 3.3 2-.2 3.3-1.2 3.2-3-.2-2-1.9-2.3-4.5-2.6-2.6-.3-4.8-.9-5-3.6-.2-2.4 1.6-4 4.5-4.2 3.6-.3 5.2 1.4 5.8 4l-1.7.2c-.4-2-1.9-2.9-4-2.7-1.9.2-3.1 1.1-3 2.6.1 1.6 1.8 2 4 2.2 2.8.3 5.4.8 5.7 4 .2 2.7-1.8 4.4-4.9 4.7-4.2.2-6.3-1.9-6.7-4.7zM110.8 8.2l11.3.9-.1 1.6-4.7-.4-1 12.7-1.8-.1 1-12.7-4.7-.4V8.2zM129.7 10.4l6.5 1.7c2.4.7 3.7 2.6 3.1 4.9-.5 1.7-1.5 2.7-3.3 2.8v.1c1.3.9 1.5 2 1.1 4.1-.4 2.3-.4 2.9-.2 3.1v.1l-1.9-.5c-.2-.3-.1-.9.3-3.2.4-2.1-.2-3-2.1-3.5l-3.9-1-1.6 5.9-1.7-.5 3.7-14zm0 7.1 4.1 1.1c1.9.5 3.2-.2 3.6-1.8.5-1.7-.1-2.7-2.1-3.3l-4.2-1.1-1.4 5.1zM151.6 17.9l1.8.9-1.3 15.2-1.8-.8.5-4.6-5.2-2.4-3.3 3.3-1.7-.8 11-10.8zm-4.8 7 4.2 2 .6-5c.1-.8.3-2.1.3-2.1l-1.5 1.5-3.6 3.6zM162.2 23.3l9.4 6.4-.9 1.3-3.9-2.7-7.2 10.5-1.5-1 7.2-10.5-3.9-2.7.8-1.3zM177.5 34.6l7.2 7.1-1.1 1.1-5.9-5.8-3.2 3.2 5.4 5.3-1.1 1.1-5.4-5.3-3.5 3.6 6.1 6-1.2 1.2-7.4-7.2 10.1-10.3zM185.9 63.7c-1.8-.1-3.3-.9-4.4-2.4-2.3-3.3-1.3-7.3 2.2-9.7 3.4-2.4 7.5-2.3 10.1 1.4 1.9 2.7 1.6 5.4-.5 7.4l-1.1-1.5c1.3-1.4 1.5-3.2.2-5-2-2.8-5-2.6-7.7-.7-2.9 2-3.6 5-2 7.4 1.7 2.4 4.1 2.4 6.1 1l.3-.2-2.5-3.5 1.3-.9 3.5 5-6.2 4.3-.7-1 1.4-1.6zM194.9 71.8l5.3-8.1.8 1.8-4.5 6.6 7.9.9.8 1.7-9.7-1.3-5.5 2.5-.8-1.6 5.7-2.5z'
      className='st0ProductStrategy'
    />
    <circle className='st1ProductStrategy' cx='108' cy='112.6' r='70' />
    <path
      className='st1ProductStrategy'
      d='M197.7 119.7c-3.9 49.6-47.2 86.6-96.8 82.7-32.7-2.6-61.5-22.8-75-52.7'
    />
    <path
      className='st18'
      transform='matrix(.9878 -.1559 .1559 .9878 -12.9496 31.8998)'
      d='M194.9 96.5h4v4h-4z'
    />
    <path
      className='st18'
      transform='matrix(.9825 -.1865 .1865 .9825 -23.7926 5.9077)'
      d='M17.5 127.4h4v4h-4z'
    />
    <path
      transform='rotate(-45 109.85474425 75.33086493)'
      className='st2ProductStrategy'
      d='M107.4 72.9h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 70.48817546 114.94199773)'
      className='st2ProductStrategy'
      d='M68 112.5h4.9v4.9H68z'
    />
    <path
      transform='rotate(-45 149.1908242 114.76056061)'
      className='st2ProductStrategy'
      d='M146.7 112.3h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 109.83179688 154.04006973)'
      className='st2ProductStrategy'
      d='M107.4 151.6h4.9v4.9h-4.9z'
    />
    <path
      className='st3ProductStrategy'
      d='M133.4 121.7v-5.6M85.2 121.7v-5.1'
    />
    <path
      className='st4ProductStrategy'
      d='M101.6 125.6H143v-3c-5.8-2.1-11-5.6-15-10.3-6.6-7.7-9.5-11.8-14.5-11.8-4.3 0-7 3-11.9 8.8v16.3zM96.3 115.2c-3.6 3.3-7.8 5.9-12.3 7.5v3h12.3v-10.5z'
    />
    <path
      className='st3ProductStrategy'
      d='M97.7 121.7h41.4v-3c-5.8-2.1-11-5.6-15-10.3-6.6-7.7-9.5-11.8-14.5-11.8-4.3 0-7 3-11.9 8.8v16.3zM92.4 111.2c-3.6 3.3-7.8 5.9-12.3 7.5v3h12.3v-10.5zM109.6 96.7v25M121.5 121.7v-16.2M94.8 101.6l2 1.2-1.4 1.6'
    />
    <path className='st3ProductStrategy' d='M96.8 102.8s-5.6-.2-5 5.6' />
  </svg>
)

export default ProductStrategy
